import React, { useState } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function CreateReferral({ uid }) {
  const [formData, setFormData] = useState({
    refName: "",
    refContact: "",
    refRelation: "",
    custContact: "",
    docName: "",
    document: ""
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    setFormData((prev) => ({
      ...prev,
      docName: event.target.files[0].name
    }));
    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          document: res
        }));
      });
    }
  };

  const handleReferralSubmit = (event) => {
    event.preventDefault();
    console.log("Submitting Service Request....");

    const referralData = {
      name: formData.refName,
      contact: formData.refContact,
      relation: formData.refRelation
    };

    console.log(referralData);

    API.saveReferral({
      name: formData.refName,
      contact: formData.refContact,
      relation: formData.refRelation,
      referrerID: uid,
      custContact: formData.custContact
    })
      .then((res) => {
        console.log("Saved Referral");
        cogoToast.success("Saved Referral");
        console.log(res.data);
        if (formData.document.length > 0) {
          if (formData.docName.length > 0) {
            API.createDocumentForReferral(res.data._id, {
              docName: formData.docName,
              document: formData.document,
              policyid: res.data._id,
              type: "referral"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Referral Document!");
              })
              .catch((_err) => console.log(_err));
          } else {
            API.createDocumentForReferral(res.data._id, {
              docName: `${formData.year + " " + formData.model} Document`,
              document: formData.document,
              policyid: res.data._id,
              type: "referral"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Referral Document!");
              })
              .catch((_err) => console.log(_err));
          }
        }
      })
      .catch((_err) => console.log(_err));
  };

  return (
    <div>
      <div
        className="card"
        style={{ borderRadius: "10px", color: "black", overflow: "auto", padding: "0" }}
      >
        <div className="card-header" style={{ textAlign: "center" }}>
          <h3 style={{ textAlign: "center" }}>Referral Bonus</h3>
          <p>
            We offer $40 as referral bonus if you put us in touch with one of your family members or
            friends!
          </p>
        </div>
        <div className="card-body" style={{ padding: "0" }}>
          <form>
            <ul>
              <li>
                <strong>Referral Name:</strong>
                <ul>
                  <li>
                    <input
                      type="text"
                      value={formData.refName}
                      onChange={handleInputChange}
                      name="refName"
                    />
                  </li>
                </ul>
              </li>
              <li>
                <strong>Referral Phone #:</strong>
                <ul>
                  <li>
                    <input
                      type="text"
                      value={formData.refContact}
                      onChange={handleInputChange}
                      name="refContact"
                    />
                  </li>
                </ul>
              </li>
              <li>
                <strong>Relation:</strong>
                <ul>
                  <li>
                    <input
                      type="text"
                      value={formData.refRelation}
                      onChange={handleInputChange}
                      name="refRelation"
                    />
                  </li>
                </ul>
              </li>
              <li>
                <strong>Your Email:</strong>
                <ul>
                  <li>
                    <input
                      type="text"
                      value={formData.custContact}
                      onChange={handleInputChange}
                      name="custContact"
                    />
                  </li>
                </ul>
              </li>
              <li>
                <strong>Documents (optional)</strong>
                <ul>
                  <li>
                    <input style={{ width: "80%" }} type="file" onChange={fileSelectedHandler} />
                  </li>
                </ul>
              </li>
            </ul>
            <div style={{ textAlign: "center" }}>
              <button
                style={{
                  color: "white",
                  fontSize: "20px",
                  boxShadow: "0px 0px 1px 1px black",
                  backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
                  padding: "5px 20px 5px 20px",
                  borderRadius: "5px"
                }}
                onClick={(e) => handleReferralSubmit(e)}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <br />
    </div>
  );
}

export default CreateReferral;
